/**
 * CompactSinCard - Ultra-compact card for grid view
 * Optimized for iPad display
 */

import type { SinRanking } from '../types';

interface CompactSinCardProps {
  sin: SinRanking;
  rank: number;
}

export function CompactSinCard({ sin, rank }: CompactSinCardProps) {
  const isTopRank = rank <= 3;

  return (
    <div className={`compact-card ${isTopRank ? 'top-rank' : ''}`}>
      {/* Rank Badge */}
      <div className={`compact-rank ${isTopRank ? 'top-rank' : ''}`}>
        #{rank}
      </div>

      {/* Sin Name */}
      <h3 className="compact-sin-name">
        {sin.name}
      </h3>

      {/* Mini Progress Bar */}
      <div className="mini-progress-bar">
        <div
          className="mini-progress-fill"
          style={{ width: `${sin.percentage}%` }}
        />
      </div>

      {/* Stats Row */}
      <div className="compact-stats">
        <span className="compact-count">{sin.count}</span>
        <span className="compact-percentage">{sin.percentage.toFixed(0)}%</span>
      </div>

      {/* Severity Indicator */}
      <div className={`compact-severity severity-${sin.severity}`}></div>
    </div>
  );
}
